import COLORS from "../../config/colors";
import Icons from "../Icons";
import { formatPhone } from "../../lib/formatPhone";

export default function BookingModal({
  show, onClose, onSubmit, loading, error,
  name, setName, email, setEmail, phone, setPhone,
  totalEstimate, tradeName, marketName, styles,
}) {
  if (!show) return null;

  const deposit = Math.round(totalEstimate * 0.165);

  return (
    <div
      style={{ position: "fixed", inset: 0, zIndex: 400, background: "rgba(0,0,0,0.55)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}
      onClick={() => !loading && onClose()}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{ background: COLORS.white, borderRadius: 20, padding: 36, width: "100%", maxWidth: 440, boxShadow: "0 12px 48px rgba(0,0,0,0.18)" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
          <div>
            <div style={{ fontSize: 20, fontWeight: 700, fontFamily: "'Playfair Display', serif", color: COLORS.bark }}>
              Book This Project
            </div>
            <div style={{ fontSize: 13, color: COLORS.stone, marginTop: 3 }}>
              16.5% deposit — <strong style={{ color: COLORS.honey }}>${deposit.toLocaleString()}</strong> of ${Math.round(totalEstimate).toLocaleString()} total
            </div>
          </div>
          {!loading && (
            <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: COLORS.stone, padding: 4 }}>
              <Icons.X />
            </button>
          )}
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 12, marginBottom: 16 }}>
          <div>
            <label style={styles.label}>Full Name</label>
            <input value={name} onChange={e => setName(e.target.value)} placeholder="Your Name" autoComplete="name" disabled={loading} style={styles.input} />
          </div>
          <div>
            <label style={styles.label}>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@email.com" autoComplete="email" disabled={loading} style={styles.input} />
          </div>
          <div>
            <label style={styles.label}>Phone</label>
            <input type="tel" value={phone} onChange={e => setPhone(formatPhone(e.target.value))} placeholder="(555) 555-0000" autoComplete="tel" disabled={loading} style={styles.input} />
          </div>
        </div>

        {error && (
          <div style={{ color: COLORS.red, fontSize: 13, marginBottom: 12, padding: "10px 14px", background: "rgba(196,75,59,0.06)", borderRadius: 8 }}>
            {error}
          </div>
        )}

        <div style={{ background: COLORS.cream, borderRadius: 10, padding: "12px 14px", marginBottom: 16, fontSize: 13 }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
            <span style={{ color: COLORS.stone }}>{tradeName || "Project"} — {marketName || ""}</span>
            <span style={{ color: COLORS.bark }}>${Math.round(totalEstimate).toLocaleString()}</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 700 }}>
            <span style={{ color: COLORS.stone }}>Signing Deposit (16.5%)</span>
            <span style={{ color: COLORS.pine }}>${deposit.toLocaleString()}</span>
          </div>
        </div>

        <button
          onClick={onSubmit}
          disabled={loading}
          style={{
            width: "100%", padding: "14px", borderRadius: 10, border: "none",
            background: loading ? COLORS.stone : COLORS.pine, color: COLORS.white,
            fontSize: 14, fontWeight: 700, cursor: loading ? "wait" : "pointer",
            fontFamily: "'DM Sans', sans-serif",
            boxShadow: loading ? "none" : "0 3px 12px rgba(74,124,89,0.3)",
            transition: "all 0.2s",
          }}
        >
          {loading ? "Creating checkout..." : `Pay Deposit — $${deposit.toLocaleString()}`}
        </button>

        <div style={{ fontSize: 11, color: COLORS.stone, textAlign: "center", marginTop: 10, lineHeight: 1.5 }}>
          Secured by Stripe. You'll be redirected to complete payment.<br />
          Fixed-bid contract — no overruns on your end.
        </div>
      </div>
    </div>
  );
}
